/* istanbul ignore file */
import type {CustomCssVarsFnParams} from '@wix/wixstores-client-storefront-common';

export const getBuyNowButtonCustomCssVars = ({styleParams}: CustomCssVarsFnParams) => {
  const isAddToCartButtonEnabled = styleParams.booleans.productPage_productAction;
  const isWishlistButtonEnabled = styleParams.booleans.productPage_wishlistEnabled;

  return {
    buyNowButtonWidth: !isWishlistButtonEnabled || isAddToCartButtonEnabled ? '100%' : 'auto',
    buyNowButtonFlexGrow: isWishlistButtonEnabled && !isAddToCartButtonEnabled ? '1' : 'revert',
    buyNowButtonMarginInlineEnd: isWishlistButtonEnabled && !isAddToCartButtonEnabled ? '8px' : '0',
  };
};
